import React from 'react';
import { Link } from 'react-router-dom';

const Datenschutz = () => {
  return (
    <div className="calculator-container" data-testid="datenschutz-page">
      <div className="calculator-card" style={{ maxWidth: '800px' }}>
        <img
          src="https://customer-assets.emergentagent.com/job_lead-wizard-5/artifacts/xohrqn39_Logo%20separatus%20vergleich.png"
          alt="separatus Vergleich"
          style={{ maxWidth: '250px', marginBottom: '2rem', display: 'block' }}
        />
        <h1 style={{ fontSize: '2rem', fontWeight: '700', color: '#1B5E20', marginBottom: '2rem' }}>Datenschutzerklärung</h1>
        
        <div style={{ lineHeight: '1.8', color: '#2E2E2E' }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginTop: '2rem', marginBottom: '1rem' }}>1. Datenschutz auf einen Blick</h2>
          <h3 style={{ fontSize: '1rem', fontWeight: '600', marginTop: '1rem' }}>Allgemeine Hinweise</h3>
          <p>
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
          </p>

          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginTop: '2rem', marginBottom: '1rem' }}>2. Datenerfassung auf dieser Website</h2>
          <h3 style={{ fontSize: '1rem', fontWeight: '600', marginTop: '1rem' }}>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</h3>
          <p>
            Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
          </p>

          <h3 style={{ fontSize: '1rem', fontWeight: '600', marginTop: '1rem' }}>Wie erfassen wir Ihre Daten?</h3>
          <p>
            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in unser Kontaktformular eingeben.
          </p>

          <h3 style={{ fontSize: '1rem', fontWeight: '600', marginTop: '1rem' }}>Wofür nutzen wir Ihre Daten?</h3>
          <p>
            Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.
          </p>

          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginTop: '2rem', marginBottom: '1rem' }}>3. Ihre Rechte</h2>
          <p>
            Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen.
          </p>

          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginTop: '2rem', marginBottom: '1rem' }}>4. Kontaktformular</h2>
          <p>
            Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
          </p>

          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginTop: '2rem', marginBottom: '1rem' }}>5. Speicherdauer</h2>
          <p>
            Wir speichern Ihre Daten so lange, wie es für die Bearbeitung Ihrer Anfrage erforderlich ist. Nach Abschluss der Bearbeitung werden Ihre Daten gelöscht, sofern keine gesetzlichen Aufbewahrungsfristen entgegenstehen.
          </p>

          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginTop: '2rem', marginBottom: '1rem' }}>6. SSL- bzw. TLS-Verschlüsselung</h2>
          <p>
            Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von "http://" auf "https://" wechselt.
          </p>
        </div>

        <div style={{ marginTop: '3rem', textAlign: 'center' }}>
          <Link to="/" className="btn-primary">
            Zur Startseite
          </Link>
        </div>
      </div>
      
      {/* Footer mit Logo und Kontaktdaten */}
      <footer style={{
        background: '#2E2E2E',
        color: 'white',
        padding: '2rem',
        marginTop: '2rem',
        width: '100%'
      }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          maxWidth: '600px',
          margin: '0 auto 1.5rem auto',
          gap: '2rem',
          flexWrap: 'wrap'
        }}>
          {/* Linke Spalte - Logo */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_lead-wizard-5/artifacts/reiotrun_Logo%20separatus%20vergleich%20weiss.png"
              alt="separatus Vergleich"
              style={{ height: '45px', objectFit: 'contain' }}
            />
          </div>
          
          {/* Rechte Spalte - Kontaktdaten */}
          <div style={{ textAlign: 'left' }}>
            <a href="tel:+41715522350" style={{ color: '#C8E6C9', textDecoration: 'none', display: 'block', marginBottom: '0.5rem' }}>
              ☎ +41 71 552 2350
            </a>
            <a href="mailto:office@separatus.ch" style={{ color: '#C8E6C9', textDecoration: 'none', display: 'block' }}>
              ✉ office@separatus.ch
            </a>
          </div>
        </div>
        
        {/* Copyright über beide Spalten */}
        <p style={{ fontSize: '0.85rem', color: '#999', margin: 0, textAlign: 'center' }}>
          © {new Date().getFullYear()} separatus. Alle Rechte vorbehalten.
        </p>
      </footer>
    </div>
  );
};

export default Datenschutz;
